import { INTEGRATION_PROVIDER_PERMISSION } from './integration-permissions.js';
import { canManagePublicApiKeys, } from './permissions.js';
/**
 * Flag che da soli aprono la tab Integrazioni: i flag di collegamento dei
 * connettori del registry (derivati da `INTEGRATION_PROVIDER_PERMISSION`,
 * così un nuovo connettore con flag dedicato entra da solo) più MCP.
 * `canAccessSettings` (Computer Gross) da solo non basta: serve anche
 * `canAccessProducts`, regola a parte in `canAccessIntegrations`.
 */
const CONNECTOR_ACCESS_FLAGS = [
    ...new Set([
        ...Object.values(INTEGRATION_PROVIDER_PERMISSION),
        'canConnectMcp',
    ]),
].filter((flag) => flag !== 'canAccessSettings');
/**
 * Flag che possono aprire la tab Integrazioni delle Impostazioni: i
 * connettori, MCP e le chiavi API. Usata solo dai test come elenco di
 * riferimento (nessun codice di produzione la importa); la
 * regola esatta è `canAccessIntegrations`, perché le chiavi API valgono solo
 * con i saldi (`canManagePublicApiKeys`).
 */
export const INTEGRATIONS_ACCESS_FLAGS = [
    ...CONNECTOR_ACCESS_FLAGS,
    'canManageApiKeys',
];
/**
 * L'utente può aprire la tab Integrazioni: un flag di collegamento, MCP, o
 * le API sviluppatori. Queste ultime seguono `canManagePublicApiKeys` (chiavi
 * + saldi), come il backend: il flag chiavi da solo non basta. Unica regola
 * per rotta, nav, tab e pallino di stato.
 */
export function canAccessIntegrations(flags) {
    return (CONNECTOR_ACCESS_FLAGS.some((flag) => flags[flag] === true) ||
        (flags.canAccessSettings === true && flags.canAccessProducts === true) ||
        canManagePublicApiKeys(flags));
}
//# sourceMappingURL=integration-access.js.map